export function HowItWorks() {
  return (
    <section id="how" className="section">
      <div className="container">
        <h2 className="section__title">How it works</h2>
        <ol className="steps">
          <li className="steps__item">
            Employees clock in/out on a mobile or tablet via fingerprint.
          </li>
          <li className="steps__item">
            Data is stored securely on the device (offline mode).
          </li>
          <li className="steps__item">
            When online, records auto-sync to the cloud.
          </li>
          <li className="steps__item">
            Managers view realtime dashboards and export payroll-ready reports.
          </li>
        </ol>
      </div>
    </section>
  );
}
